import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import AddOrderDetails from "./AddOrderDetails";
import Pagination from "../../Common/Pagination/Pagination";
import UpdateGovtOrderDetails from "./UpdateGovtOrderDetails";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";

const ViewGovtOrder = () => {
  const gridRef = useRef(null);
  const params = useParams();
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const navigate = useNavigate();
  const handleNavigate = () => {
    setOrderDetails([]);
    navigate("/govt-order");
  };
  const [storeProduct, setStoreProduct] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  // console.log(orderDetails)
  // const [orderData, setOrderData] = useState([]);
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowId, setRowId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const formetDate = moment(orderDetails.rca_date).format("YYYY-MM-DD");
  const formRef = useRef(null);
  const order_id = params.order_id;

  // console.log(orderDetails.id)

  const [filterCriteria, setfilterCriteria] = useState({
    govt_order_id: parseInt(order_id),
  });
  // console.log(filterCriteria)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    // gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    // gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  // console.log("formetDate" + formetDate)
  const getSingleData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/govt-order/single-govt-order/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setOrderDetails(result.data);
    } else {
      setOrderDetails([]);
    }
  };

  useEffect(() => {
    if (order_id) {
      getSingleData();
    }
  }, [order_id]);

  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );

  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/govt-order/all-govt-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "post",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };
  useEffect(() => {
    if (order_id) {
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
  }, [currentPage, pageSize, filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };

  const deleteOrderDetailData = async (order_id) => {
    const message = "Do you want to delete this govt RCA details!";

    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/govt-order/govt-order-details/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
      getSingleData();
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View RCA Order &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="party">Region</label>
                    <input
                      type="text"
                      className="form-control"
                      name="o_m_circle"
                      id="party"
                      placeholder="Region"
                      value={orderDetails?.discomList?.discom_name}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="Pole">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="company_name"
                      id="Pole"
                      value={
                        orderDetails?.companyDetails?.company_name +
                        ", " +
                        orderDetails?.companyDetails?.location
                      }
                      readOnly
                      placeholder="Company Name"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="date">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="rca_date"
                      id="date"
                      placeholder="Date"
                      value={formetDate}
                      readOnly
                      min={minDate}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="pole_date">RCA.NO</label>
                    <input
                      type="text"
                      className="form-control"
                      name="date"
                      id="pole_date"
                      placeholder="RCA.NO"
                      value={orderDetails?.rca_number}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {orderDetails?.alloted_details?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="size">Size</label>
                          <input
                            type="text"
                            className="form-control"
                            name="size"
                            id="size"
                            placeholder="Size"
                            value={item.size}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="alloted_qty">Alloted Region</label>
                          <input
                            type="text"
                            className="form-control"
                            name="alloted_qty"
                            id="alloted_qty"
                            placeholder="Alloted Qty"
                            value={item.alloted_qty}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="balance_qty">Region Balance</label>
                          <input
                            type="text"
                            className="form-control"
                            name="balance_qty"
                            id="balance_qty"
                            placeholder="Payment Terms"
                            value={item.balance_qty}
                            readOnly
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
              <div>
                <h6 style={{ marginTop: "20px" }}>
                  <i className="fa fa-info-circle"></i> Total Alloted:{" "}
                  {orderDetails?.total_alloted}
                </h6>
              </div>
              <div>
                <h6 style={{ marginTop: "20px" }}>
                  <i className="fa fa-info-circle"></i> Total Balance:{" "}
                  {orderDetails?.total_balance}
                </h6>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="card mt-2">
        <div className="private-table-container">
          <div className="card-body">
            <div className="table_btn">
              <div className="mb-3">
                <button
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add RCA Details
                </button>
              </div>
              <div
                style={{
                  marginBottom: "20px",
                }}
              ></div>
            </div>
            <div
              className="table-responsive table-bordered"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Alloted Quantity</th>
                    <th>Region</th>
                    <th>Circle</th>
                    <th>Size</th>
                    <th>Rate</th>
                    <th>GST %</th>
                    {/* <th>Order Details</th>
                    <th>RCA Quantity</th>
                    <th>Order Quantity</th>
                    <th>RCA Balance</th> */}
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData?.length > 0 ? (
                    rowData &&
                    rowData?.length > 0 &&
                    rowData?.map((item, index) => (
                      <tr key={index}>
                        {/* <td style={{ padding: "10px" }}>{index + 1}</td> */}
                        <td style={{ padding: "10px" }}>
                          {(currentPage - 1) * pageSize + index + 1}
                        </td>
                        <td>{item.alloted_qty}</td>
                        <td>{item.region}</td>
                        <td>{item.circle}</td>
                        <td>{item.product_name}</td>
                        <td>{item.rate}</td>
                        <td>{item.gst_percent}</td>
                        {/* <td>
                        <input
                          type="text"
                          className="form-control"
                          name="order_details"
                          placeholder="Order Details"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          name="rca_qty"
                          placeholder="RCA Quantity"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          name="order_qty"
                          placeholder="Order Quantity"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          name="rca_balance"
                          placeholder="RCA Balance"
                        />
                      </td> */}
                        {/* Other input fields */}
                        <td style={{ padding: "10px", textAlign: "center" }}>
                          <button
                            className="btn btn-outline-secondary btn-sm ml-2"
                            onClick={() => addDataToModal(item.id)}
                            data-toggle="modal"
                            data-target="#updateModal"
                          >
                            <i className="mdi mdi-note-edit-outline" />
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm ml-2"
                            onClick={() => deleteOrderDetailData(item.id)}
                          >
                            <i className="mdi mdi-delete" />
                          </button>{" "}
                          <NavLink
                            className="btn btn-outline-info btn-sm ml-1"
                            to={`/view-govt-order_details/${item.id}`}
                          >
                            <i className="mdi mdi-eye-arrow-right-outline" />
                          </NavLink>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <AddOrderDetails
              order_id={order_id}
              formRef={formRef}
              size={orderDetails?.alloted_details}
              getData={getData}
              getSingleData={getSingleData}
              discomId={orderDetails?.discomList?.id}
            />
            <UpdateGovtOrderDetails
              setRowId={setRowId}
              rowId={rowId}
              getData={getData}
              discomId={orderDetails?.discomList?.id}
              size={orderDetails?.alloted_details}
              setOrderDetails={setOrderDetails}
            />
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default ViewGovtOrder;
